export const CSS = {
  active: "is-active",
  open: "is-open",
  overflowHidden: "overflow--hidden",
  visible: "is-visible",
};
